export default __webpack_public_path__ + "static/demo-square-9ae4d5717f27c40e2a3bc3a2dbccb111.jpg";